import * as z from 'zod';

import { applicationFormConsultationLevelId } from '@/features/original-plus/constants/application-form.constants';

const applicationLevelIds = [
  'start',
  'growth',
  'pro',
  'production',
  applicationFormConsultationLevelId,
] as const;

export const originalPlusApplicationSchema = z.object({
  pseudonym: z.string().trim().min(1, 'Укажите псевдоним или имя для публикации'),
  contact: z.string().trim().min(1, 'Укажите контакт для связи'),
  workLink: z.string(),
  levelId: z.enum(applicationLevelIds),
  personalDataAccepted: z.boolean().refine((value) => value, {
    message: 'Необходимо согласие на обработку персональных данных',
  }),
  rightsConfirmed: z.boolean().refine((value) => value, {
    message: 'Подтвердите, что обладаете правами на произведение',
  }),
  rulesAccepted: z.boolean().refine((value) => value, {
    message: 'Необходимо согласие с правилами рассмотрения заявки',
  }),
});

export type OriginalPlusApplicationFormValues = z.infer<typeof originalPlusApplicationSchema>;
